import React from "react";
import { useSelector } from "react-redux";
import './Error.scss'
import ErrorImg from '../../assets/image/ico-locked.svg'
import { ERROR_DISABLE_ACCESS, ERROR_DISABLE_CONSTANT, ERROR_DISABLE_HEADING, ERROR_SOMETIMES } from "../../constants/Constantsi18";

const Error = () => {

  const { userInfo } = useSelector((state:any) => ({ userInfo: state.loginResource }));

  return (
    <div key={"error"} id={"error"} className="centered no_access_page">
      {/* <img
        src={require("../../assets/image/ico-locked.svg")}
        alt="icon"
        style={{ height: "14rem" }}
        className="col-sm-7 offset-md-3"
      /> */}
      <ErrorImg />

      {userInfo?.is_maintenance_mode ?
        <>
          <div className="col-sm-7 offset-md-3 font-weight-bold h4 text-center mt-4 text-muted">
            {ERROR_DISABLE_HEADING}
          </div>
          <div className="col-sm-7 offset-md-3 text-center mt-4">
            <small className="font-weight-bold text-secondary">
              {ERROR_SOMETIMES}
            </small>
          </div>
          <div className="col-sm-7 offset-md-3 mt-4 border-top">
            <small className="text-muted" />
          </div>
        </>
        :
        <>
          <div className="col-sm-7 offset-md-3 font-weight-bold h4 text-center mt-4 text-muted">
            {ERROR_DISABLE_ACCESS}
          </div>
          <div className="col-sm-7 offset-md-3 text-center mt-4">
            <small className="font-weight-bold text-secondary">
              {ERROR_DISABLE_CONSTANT}
            </small>
          </div>
          <div className="col-sm-7 offset-md-3 mt-4 border-top">
            <small className="text-muted" />
          </div>
        </>}

    </div>
  );
};

export default Error;
